import { viewport } from '../../utils/viewport';

document.querySelectorAll('.hero__cta--jobs button').forEach((button) => {
  const jobsBlock = document.querySelector('.jobs');

  if (jobsBlock) {
    button.addEventListener('click', () => {
      jobsBlock.scrollIntoView({ behavior: 'smooth' });
    });

    viewport.observe(
      jobsBlock,
      () => button.classList.add('hidden'),
      () => button.classList.remove('hidden')
    );
  } else {
    button.parentElement.removeChild(button);
  }
});